import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetBuildingsConsumption_reminder_alerts = z.any()
export type TagsGetBuildingsConsumption_reminder_alerts = z.infer<typeof tagsGetBuildingsConsumption_reminder_alerts>

export const querystringGetBuildingsConsumption_reminder_alerts = z.object({ "buildingId": z.string().uuid().optional() })
export type QuerystringGetBuildingsConsumption_reminder_alerts = z.infer<typeof querystringGetBuildingsConsumption_reminder_alerts>

export const responseGetBuildingsConsumption_reminder_alerts = z.object({ "payload": z.array(z.object({ "collectionPointId": z.string(), "collectionPointName": z.string(), "buildingId": z.string(), "buildingName": z.string(), "lastConsumptionAt": z.union([z.string(), z.null()]), "dueDate": z.string(), "daysOverdue": z.number(), "alertType": z.enum(["DUE","OVERDUE"]), "consumptionReminderFrequency": z.enum(["weekly","monthly","yearly"]).optional(), "title": z.string(), "message": z.string(), "actionPath": z.string() })).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetBuildingsConsumption_reminder_alerts = z.infer<typeof responseGetBuildingsConsumption_reminder_alerts>

interface IGetBuildingsConsumption_reminder_alerts extends BaseMethodType {
  tags: TagsGetBuildingsConsumption_reminder_alerts,
  querystring: QuerystringGetBuildingsConsumption_reminder_alerts,
  response: ResponseGetBuildingsConsumption_reminder_alerts
}
export const URL = '/buildings/consumption-reminder-alerts'
export const validation = {
  get: {
    tags: tagsGetBuildingsConsumption_reminder_alerts,
    querystring: querystringGetBuildingsConsumption_reminder_alerts,
    response: responseGetBuildingsConsumption_reminder_alerts
  }
}
export interface BuildingsConsumption_reminder_alerts extends BaseRouteType {
  get: IGetBuildingsConsumption_reminder_alerts
}